module.exports = __webpack_public_path__ + "static/img/advantage.765e7f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advantage.png
// module id = VNWx
// module chunks = 0